var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { deburr, escapeRegExp, uniqBy } from 'lodash';
import { json } from 'overmind';
import Input from 'components/Input.vue';
let ActivityPanel = class ActivityPanel extends Vue {
    constructor() {
        super(...arguments);
        this.filteredFilters = json(this.filters);
        this.radioButtonValue = this.radioButtonCnae;
        this.filterOptions = this.filters.map(f => f.filterOptions);
        this.searchTerm = '';
        this.currentFilterIndex = 0;
    }
    onFullTextSearchChange(curr, old) {
        this.searchTerm = this.fullTextTerm;
        this.filters.forEach(f => {
            this.onSearchFilters(f, this.fullTextTerm);
            this.currentFilterIndex += 1;
        });
        this.currentFilterIndex -= 1;
    }
    async onFilterIndexChange(curr, old) {
        this.filterOptions[curr] =
            this.filters[this.currentFilterIndex].filterOptions;
    }
    onFiltersChange(curr, old) {
        if (curr) {
            // @ts-ignore
            this.filters = curr;
            //this.filters = Object.freeze(json(this.filters));
        }
    }
    get selectedCount() {
        return (groupTag) => {
            const filter = json(this.filters.find(filter => filter.groupTag === groupTag));
            if (filter) {
                return filter.filterOptions.filter(option => option.isSelected).length;
            }
            else {
                return 0;
            }
        };
    }
    onSearchFilters(filter, event) {
        if (event == null) {
            this.filteredFilters[this.currentFilterIndex].filterOptions = json(this.filterOptions[this.currentFilterIndex]);
            return;
        }
        let filterOptions = json(this.filterOptions[this.currentFilterIndex].filter(o => {
            const deburedTerm = escapeRegExp(deburr(this.searchTerm));
            if (o.tags) {
                const debured = deburr(Array.isArray(o.tags) ? o.tags.join(', ') : [o.tags].join(', '));
                const deburedMatch = debured.match(new RegExp(deburedTerm, 'gi'));
                if (deburedMatch)
                    return deburedMatch;
            }
            const deburedLabel = o.label ? deburr(o.label) : undefined;
            return o.label && deburedLabel
                ? deburedLabel.match(new RegExp(deburedTerm, 'i'))
                : false;
        }));
        filterOptions = uniqBy(filterOptions, 'value');
        this.filteredFilters[this.currentFilterIndex].filterOptions =
            json(filterOptions);
    }
    onHideFilter(filterIndex) {
        if (this.fullTextTerm === '') {
            this.filteredFilters[filterIndex].filterOptions = json(this.filterOptions[filterIndex]);
        }
    }
    onShowFilter(filterIndex) {
        this.currentFilterIndex = filterIndex;
        this.searchTerm = '';
    }
    setCheckbox(filterGroupId, filterId, filterIndex, filterOptionIndex, value, itemId) {
        const option = this.filteredFilters[filterIndex].filterOptions.find(o => o.value === itemId);
        if (option) {
            this.filteredFilters[this.currentFilterIndex].filterOptions[filterOptionIndex].isSelected = value;
        }
        this.$emit('setCheckbox', filterGroupId, filterId, filterIndex, filterOptionIndex, value, itemId);
    }
    setSelectedRadioButton(queryField, from) {
        return { queryField, from };
    }
    beforeDestroy() {
        this.filteredFilters[this.currentFilterIndex].filterOptions = json(this.filterOptions[this.currentFilterIndex]);
    }
    mounted() {
        this.searchTerm = this.fullTextTerm;
        if (this.fullTextTerm !== '') {
            this.filters.forEach(f => {
                this.onSearchFilters(f, this.fullTextTerm);
                this.currentFilterIndex += 1;
            });
            this.currentFilterIndex -= 1;
        }
    }
};
__decorate([
    Prop({ default: () => [] })
], ActivityPanel.prototype, "filters", void 0);
__decorate([
    Prop({ default: '' })
], ActivityPanel.prototype, "radioButtonCnae", void 0);
__decorate([
    Prop({ default: 1 })
], ActivityPanel.prototype, "filterGroupId", void 0);
__decorate([
    Prop({ default: '' })
], ActivityPanel.prototype, "fullTextTerm", void 0);
__decorate([
    Watch('fullTextTerm')
], ActivityPanel.prototype, "onFullTextSearchChange", null);
__decorate([
    Watch('currentFilterIndex')
], ActivityPanel.prototype, "onFilterIndexChange", null);
__decorate([
    Watch('filters')
], ActivityPanel.prototype, "onFiltersChange", null);
__decorate([
    Emit('setSelectedRadioButton')
], ActivityPanel.prototype, "setSelectedRadioButton", null);
ActivityPanel = __decorate([
    Component({
        name: 'ActivityPanel',
        components: {
            Input,
        },
    })
], ActivityPanel);
export default ActivityPanel;
